import { Text } from '@chakra-ui/react';

import { useGiftcard } from 'context/giftcard';
import { useGiftcardsPagesLayoutContent } from 'context/giftcardsPagesLayoutContent';
import { useNetwork } from 'context/network';

export const Expired = () => {
  const { giftcard } = useGiftcard();

  const { network } = useNetwork();

  const { statuses } = useGiftcardsPagesLayoutContent();

  const {
    expiredGiftcardTitle,
    expiredGiftcardDescription,
    expiredSponsoredGiftcardTitle,
    expiredSponsoredGiftcard,
  } = statuses;

  const isSponsoredGiftcard = Boolean(giftcard.activation.sponsor);

  const expiredTitle = isSponsoredGiftcard
    ? expiredSponsoredGiftcardTitle
    : expiredGiftcardTitle;

  const expiredDescription = isSponsoredGiftcard
    ? expiredSponsoredGiftcard
    : expiredGiftcardDescription;

  const networkName =
    network?.networkType === 'COMMUNITY'
      ? network.legalEntityName
      : giftcard.contextName;

  const descriptionData = {
    shortId: giftcard.shortId,
    expiredAt: giftcard.formatted.expiredAt,
    contactName: networkName,
  };

  const description = Object.entries(descriptionData).reduce(
    (acc, [key, value]) => {
      const varRegex = new RegExp(`<<${key}>>`, 'gi');

      return acc.replace(varRegex, value);
    },
    expiredDescription,
  );

  return (
    <>
      <Text fontWeight="bold" fontSize="1.25rem" mr="auto">
        {expiredTitle}
      </Text>

      <Text
        fontSize="1.25rem"
        whiteSpace="pre-line"
        data-testid="expired-giftcard-description"
      >
        {description}
      </Text>
    </>
  );
};
